import { provideChameleonDesignSystem } from '../provideChameleonDesignSystem';
import { chameleonNumberField } from './NumberField.definition';
export function registerCustom(prefix, node) {
    return provideChameleonDesignSystem({ prefix, node }).register(chameleonNumberField({ prefix }));
}
